<template>
    <div class="light-grey-bg">
    <v-container>
        <v-layout row wrap justify-center class="program">
            <v-flex xs12>
                <p class="small-title"><a @click="$router.push({name: 'programs'})">Programs</a></p>
            </v-flex>
            <v-flex xs12 class="program-title">
                <h1>SC Working Families Child Care Scholarship</h1>
            </v-flex>
<v-flex md8>
                <v-card class="program-info" style="margin: 0 auto;">
                    <img class="program-image" src="/images/dss-sq.png" />
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 align-self-center align-center>
                                <div style="margin: 0 auto;">
                                    <table>
                                        <tr>
                                            <td><img src="/images/icons/day.png"/></td>
                                            <td>Length of Day</td>
                                            <td>Full Day</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/year.png"/></td>
                                            <td>Length of Year</td>
                                            <td>Summer, School Year, Extended Day</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/car.png"/></td>
                                            <td>Transportation</td>
                                            <td>Varies</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/curriculum.png"/></td>
                                            <td>Curriculum</td>
                                            <td>Varies</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/cost.png"/></td>
                                            <td>Cost</td>
                                            <td>$6-$20 per child per week</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/location.png"/></td>
                                            <td>Location</td>
                                            <td>Child Care Center, Family Child Care Home</td>
                                        </tr>
                                    </table>
                                </div>
                            </v-flex>
                            <v-flex class="program-overview" xs12>
                                <div style="margin: 0 auto; background: #1b3675;color: white;">
                                    <h3>Program Overview</h3>
                                    <p>
                                         The Child Care Scholarship Program, accepted at more than 1,900 enrolled South Carolina providers, makes all or a portion of payments directly to providers to make child care more 
                                         affordable for parents who are working, attending school or training. 
                                         The newest offering is the SC Working Families Child Care Scholarship.
                                    </p>
                                </div>
                            </v-flex>
                            <v-flex xs12>
                                    <v-carousel>
                                      <v-carousel-item
                                        v-for="(item,i) in items"
                                        :key="i"
                                        :src="item.src"
                                      ></v-carousel-item>
                                    </v-carousel>                               
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>Transportation Offered</h3>
                                <p>
                                    The SC Working Families Child Care Scholarship pays for child care services only and does not cover transportation. However, some child care programs do offer child care transportation within their own programs.
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>Type of Service</h3>
                                <p>
                                    The SC Working Families Child Care Scholarship pays for child care services in child care facilities and family child care homes that are enrolled in ABC Quality for families that meet the program eligibility criteria.
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>Cost</h3>
                                <p>
                                    When determined eligible for child care assistance with the Child Care Scholarship Program, parents may be required to pay a co-pay directly to the child care program. Co-pays range from $6 - $20 per child, per week based on the family’s gross monthly income, 
                                    family size and whether the services they qualify for requires a co-pay. Funding categories such as TANF and Foster Care do not have client co-pays.
                                    SC Working Families Child Care Scholarship payment rates are paid up to the maximum rates based on the most recent Market Rate Survey.
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>Eligibility for Services</h3>
                                <p> The SC Working Families Child Care Scholarship offers a wide variety of funding categories. Eligibility is specific to the category for which the family applies. Generally, the criteria to apply for child care assistance is the parent must be working, 
                                    in school, or in a training program, have a need for child care for a minimum of 15 hours per week, and the family must meet all eligibility and income criteria based on the gross monthly income and family size. 
                                    Some categories have more stringent criteria. If a family feels they may be eligible for child assistance through the SC Working Families Child Care Scholarship Program, they may call 1-800-476-0199 for more information.
                                </p>
                                <v-btn round large=true color="primary" @click="$router.push({name: 'eligibility'})"><span class="btn-white">Check Eligibility</span></v-btn>
                                <hr>
                            </v-flex>
                        </v-layout>        
                    </v-card-title>
                    <v-card-actions>
                        <v-btn flat color="primary" @click="$router.push({name: 'programs'})">&lt; Back to Programs</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex md4>
                <v-layout row wrap>
                    <v-flex class="" xs12>
                        <v-card class="contact-sidebar" color="primary" style="color: white;text-align:left;">
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <h2>Contact</h2>
                                            <p class="bold">1535 Confederate Avenue<br/>Columbia, SC 29201</p>
                                            
                                            <p>Phone: <a href="tel:1-800-476-0199">1-800-476-0199</a></p>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                    <v-flex xs12>
                        <v-card class="quote-sidebar" color="lightblue" style="color: white;">
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <img src="/images/icons/quote-icon.png"/>
                                        <p>
                                            “I am so thankful for the SC Working Families Child Care Scholarship.  It has truly enhanced my stepdaughter’s life.  
                                            When life threw us a curve ball and put her with us full time, having access to the program enabled us to give her a stable learning environment in child care while we worked.”
                                        </p>
                                        <br/>
                                        <span>- SC Working Families Child Care Scholarship Program Parent</span>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
    <div class="grey-bg">
        <v-container>  
        <v-card>
            <v-card-title class="cta-card">
                <v-layout row wrap justify-center align-center>
                    <v-flex xs12 sm4 class="red-section">
                        <img alt="" src="/images/icons/icon.png"/>
                    </v-flex>
                    <v-flex xs12 sm8 class="cta-card-text">
                        <v-layout row wrap justify-center align-center>
                            <v-flex xs10>
                                <div class="red-section-content">
                                    <h2>Find Preschool Options Near You!</h2>
                                    <p>Find the preschools that offer programs for which your child is eligible. Simply enter your address to find a center located near you.</p>
                                </div>
                            </v-flex>
                            <v-flex xs2 class="arrow-img">
                                <a href="/provider-search"><img alt="Provider Search" src="/images/icons/arrow.png"/></a>
                            </v-flex>
                        </v-layout>  
                    </v-flex>
                </v-layout>
            </v-card-title>
        </v-card>
        </v-container>
    </div>
    </div>
</template>
<style scoped>

    .program{
        margin: 0 auto;
        text-align: center;
    }
    .red-section{
        background: #e94342;
        text-align: center;
    }

    .cta-card{
        padding: 0;    
    }

    .cta-card-text{
        padding: 15px 15px;
    }
</style>

<script>
     export default {
    data () {
      return {
        items: [
          {
            src: '/images/slides/video2.png'
          },
          {
            src: '/images/slides/video3.png'
          },
          {
            src: '/images/slides/video4.png'
          }
        ]
      }
    }
  }
</script>